export const spots = [
  { key: 'birthday_cafe' },
  { key: 'experience_space' },
  { key: 'billboard_ad' },
  { key: 'landmark' },
  { key: 'foodie_spot' }
];
